/**
 * Created by Ning Jiang on 11/11/2019.
 */

import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {NoWinSymbolsWinPresentationController} from "@nolimitcity/slot-game/bin/game/winpresentation/nowinsymbols/NoWinSymbolsWinPresentationController";
import {DeadwoodParsedGameData} from "../../server/data/DeadwoodParsedGameData";

export class DWNoWinPresentationController extends NoWinSymbolsWinPresentationController {

    private _deadwoodData:DeadwoodParsedGameData;

    constructor(indexes:[number, number]) {
        super(indexes, {noWinStateFadeInDuration : 1});
    }

    protected parseFeatureGameData(data:DeadwoodParsedGameData):void {
        this._deadwoodData = data;
        if(!this.hasWin()) {
            return;
        }

        super.parseFeatureGameData(data);

        if(this._deadwoodData.bonusTriggeredThisSpin || this._deadwoodData.fsSuperModeActive) {
            this._symbolWinStates[0][this._deadwoodData.bonusPositions[0]] = true;
            this._symbolWinStates[4][this._deadwoodData.bonusPositions[4]] = true;
        }

        // remove fs retrigger B from nowin symbols
        if(this._deadwoodData.mode != GameMode.NORMAL && !this._deadwoodData.fsSuperModeActive) {
            if(this._deadwoodData.bonusPositions[0] > -1) {
                this._symbolWinStates[0][this._deadwoodData.bonusPositions[0]] = true;
            }
            if(this._deadwoodData.bonusPositions[4] > -1) {
                this._symbolWinStates[4][this._deadwoodData.bonusPositions[4]] = true;
            }
        }

        if(this._deadwoodData.freespinTriggeredThisSpin) {
            this._symbolWinStates[1][this._deadwoodData.scatterPositions![1]] = true;
            this._symbolWinStates[2][this._deadwoodData.scatterPositions![2]] = true;
            this._symbolWinStates[3][this._deadwoodData.scatterPositions![3]] = true;
        }
    }

    // Add the freespins, so it can handle the no win symbols even when there is no win.
    protected hasWin():boolean {
        return super.hasWin() || this._deadwoodData.freespinTriggeredThisSpin;
    }
}